import getOperation from "../../helpers/getOperation"

import CreateUploadUrlsOutputShape from "./CreateUploadUrlsOutputShape"

export {
  CreateUploadUrlsOutputShape
}

export const createUploadUrlsOperation = getOperation("storage/CreateUploadUrls")
